import { SharedServiceRegistry } from './../../../../shared/shared-service-registry';
import { UserPreferenceService } from './../../../../layout/home/services/user-preference.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ResourceService, AlertService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SimpleEntityDataService } from './../../../../shared/services/searchable-entity/simple-entity/simple-entity-data.service';
import { SearchService } from './../../../../shared/search/search.service';
import { SearchParams } from '../../../../shared/search/models/search-params.model';
import { SearchStatus } from './../../../../shared/search/models/search-status.model';
import { ViewAllPrintJobsButtonService } from './../services/view-all-print-jobs-button.service';
import { UserPreferenceEvent, DELETE_FAVOURITE, ADD_FAVOURITE } from '../../../../shared/models/user-favourite-event';
import { ViewAllPrintJobsActionService } from '../services/view-all-print-jobs-action.service';
import { SearchEvent } from '../../../../shared/search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../../../shared/search/search-constants';

@Component({
  selector: 'lfwms-view-all-print-jobs-search',
  templateUrl: './view-all-print-jobs-search.component.html',
  styleUrls: ['./view-all-print-jobs-search.component.css'],
  providers: []
})
export class ViewAllPrintJobsSearchComponent implements OnInit {

  private alertService: AlertService;
  private resourceService: ResourceService;
  private userPreferenceService: UserPreferenceService;
  private favouritePreference: any;
  protected searchParams: SearchParams;
  protected searchStatus: SearchStatus;
  public isFavourite: boolean = false;
  public searchService: SearchService;

  constructor(coreServiceRegistry: CoreServiceRegistry,
      sharedServiceRegistry: SharedServiceRegistry,
      public dataService: SimpleEntityDataService,
      public buttonService: ViewAllPrintJobsButtonService,
      public actionService: ViewAllPrintJobsActionService) {
    this.resourceService = coreServiceRegistry.resourceService;
    this.alertService = sharedServiceRegistry.alertService;
    this.userPreferenceService = sharedServiceRegistry.userPreferencesService;
  }

  public getLabel(key: string): string {
    return this.resourceService.get(key);
  }

  public ngOnInit() {
    this.userPreferenceService
      .fetchTablePreferences('printjobtd', 'FAVOURITECONFIG')
      .subscribe((favouritePreference: any) => {
        this.favouritePreference = favouritePreference;
        this.isFavourite = this.favouritePreference.configuration.favourite;
      });
    this.userPreferenceService.receiveEvent()
      .subscribe((event: UserPreferenceEvent) => {
        if (event.source === 'search') {
          // if this event originated from the search page, ignore it. It will be handled separately
          return;
        }
        if (event.type === DELETE_FAVOURITE) {
          if (!this.favouritePreference.preferenceId
              || (event.preferenceId === this.favouritePreference.preferenceId)) {
            this.isFavourite = false;
            this.favouritePreference.configuration.favourite = false;
            this.favouritePreference.preferenceId = null;
          }
        }
      });
    this.searchService = this.dataService.searchService;
    this.searchService.setSearchCriteria({
      conditions: []
    });
    this.searchService.fetchMetadata()
      .subscribe(() => {
        this.searchService.isSearchFilterInitialized = true;
        this.searchService.performSearch();
      });
    this.searchService.receiveEvent()
      .subscribe(($event: SearchEvent) => {
        if ($event.type === NEW_SEARCH_EVENT) {
          this.actionService.showSearchFilterPopup = false;
        }
      });
  }

  public toggleFavourites() {
    // if the page is set as favourite
    if (!this.isFavourite) {
      this.favouritePreference.configuration.favourite = true;
      this.userPreferenceService
        .saveTablePreferences(this.favouritePreference)
        .subscribe((data: any) => {
          this.isFavourite = true;
          this.favouritePreference.preferenceId = data['preferenceId'];
          this.notifyUserPreferenceEvent(ADD_FAVOURITE);
          this.alertService.success(this.resourceService.get('msg_fav_add'));
        }, (error: any) => {
          this.alertService.clearAll().error(this.resourceService
            .get(error.error.errors['0'].validationMessage));
        });
    } else {
      this.userPreferenceService
        .deleteFavorites(this.favouritePreference.preferenceId)
        .subscribe((data: any) => {
          this.notifyUserPreferenceEvent(DELETE_FAVOURITE);
          this.isFavourite = false;
          // Resetting favourites flag logic will be handled inside above event callback
          this.alertService.success(this.resourceService.get('msg_fav_del'));
        });
    }
  }

  private notifyUserPreferenceEvent(type: number, isExternal?: boolean) {
    const event = new UserPreferenceEvent();
    event.type = type;
    event.source = 'search';
    if (isExternal) {
      event.isExternal = isExternal;
    }
    this.userPreferenceService.notifyEvent(event);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/view-all-print-jobs/view-all-print-jobs-search/view-all-print-jobs-search.component.ts